import { routeMappings } from '../../constants';
import { Template, User, WorkflowItem } from '../../store/interfaces';
import { removeLaunchConfig } from './launchConfig';
import { getExperienceInitCookie } from './experienceInitCookie';
import { SessionStore } from '../../constants/sessionStore';
import { showCandidateConsent } from '../../proctoring/utils/proctoringConfig';
import { getCookie } from './cookies';
import { getAssessmentUrlApp } from '../../taskList/utils/getAssessmentUrlApp';
import { handleTCPlusRedirection } from './handleTCPlusRedirection';
import { getStore } from '../../store';

export const redirectUrlOnAuthentication = async (
  currentWfItem: WorkflowItem,
  { template, candidate }: { template: Template; candidate: User },
): Promise<string> => {
  removeLaunchConfig(currentWfItem);
  const companySettings = getStore()?.state?.companySettings;
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const experienceInitCookie = getExperienceInitCookie();
  const isDPNEnabled = tcPlusFlow
    ? companySettings && companySettings.showDpn
    : experienceInitCookie && experienceInitCookie.showDPN;
  const dpnAccepted = sessionStorage.getItem(SessionStore.dpnAccepted);
  let url = `${routeMappings[currentWfItem.code]}/${currentWfItem.id}`;
  if (isDPNEnabled && dpnAccepted !== 'true' && !tcPlusFlow) {
    return routeMappings['DPN'];
  } else if (tcPlusFlow && experienceInitCookie && experienceInitCookie.autoLogin && dpnAccepted !== 'true')
    return routeMappings['AUTH_WELCOME'];
  else if (tcPlusFlow && companySettings && formStatus) {
    return handleTCPlusRedirection(url, template);
  } else if (showCandidateConsent()) {
    return routeMappings['CANDIDATE_CONSENT'];
  } else if (!tcPlusFlow) {
    // set in order to redirect to next item
    sessionStorage.setItem(SessionStore.dpnAccepted, 'true');
    // Check if we can load assessment
    const launchAssessmentConfig = sessionStorage.getItem(SessionStore.launchconfig);
    const parsedLaunchAssessmentConfig = launchAssessmentConfig && JSON.parse(launchAssessmentConfig);
    if (parsedLaunchAssessmentConfig && (await getAssessmentUrlApp(parsedLaunchAssessmentConfig, candidate))) return '';
    if (parsedLaunchAssessmentConfig)
      url = `${routeMappings['TASK']}/${parsedLaunchAssessmentConfig.taskId}${routeMappings['EXPASSES']}/${parsedLaunchAssessmentConfig.itemId}`;
  }

  return url;
};
